import fi from './fi'
import en from './en'

export default {
  fi,
  en
}
